import React from 'react';
import PropTypes from 'prop-types';
import Title from '../../../../components/Title';
import PageSectionTitle, {
  PageSectionTextType,
} from '../../../../components/PageSectionTitle';
import { TextType } from '../../../../components/Text';
import CreatorCard, {
  CreatorCardDataType,
} from '../../../../components/CreatorCard';
import { isDesktop } from '../../../../utility/domHelpers';
import MaxWidthContainer from '../../../../components/MaxWidthContainer';
import DragCarousel from '../../../../components/DragCarousel';

import './CourseCards.scss';

const className = 'c-HomePageContainer-CourseCards';

const CourseCards = ({ subTitle, mainTitle, creatorProps, isDesktopView }) => {
  const renderCreatorCards = () =>
    creatorProps.map((creator, i) => {
      const delay = isDesktop ? i * 50 : 0;
      return <CreatorCard key={i} order={delay} {...creator} />;
    });

  return (
    <MaxWidthContainer>
      <div className={className}>
        <Title text={subTitle} />
        {mainTitle && <PageSectionTitle title={mainTitle} />}

        {/* Cards Carousel */}
        {/* arrowDraggable value is the scroll value on arrow click to shift the carousel */}
        <DragCarousel gap={16} arrows={true} arrowDraggable={296}>
          {renderCreatorCards()}
        </DragCarousel>
      </div>
    </MaxWidthContainer>
  );
};

CourseCards.propTypes = {
  subTitle: TextType,
  mainTitle: PageSectionTextType,
  creatorProps: PropTypes.arrayOf(CreatorCardDataType),
};

export default CourseCards;
